export const SET_SEARCH_KEY = 'SET_SEARCH_KEY';
export const RESET_SEARCH_KEY = 'RESET_SEARCH_KEY';

export const REQUEST_RESULTS = 'REQUEST_RESULTS';
export const RECEIVE_RESULTS = 'RECEIVE_RESULTS';
export const SET_RESULTS_ERROR = 'SET_RESULTS_ERROR';

export const REQUEST_RESULT = 'REQUEST_RESULT';
export const RECEIVE_RESULT = 'RECEIVE_RESULT';
export const RESET_RESULT_DATA = 'RESET_RESULT_DATA';

export const SET_CURRENT_PAGE_ADVANCED = 'SET_CURRENT_PAGE_ADVANCED';
export const SET_CURRENT_IPP_ADVANCED = 'SET_CURRENT_IPP_ADVANCED';
export const SET_SORT_OPTION_ADVANCED = 'SET_SORT_OPTION_ADVANCED';
export const REQUEST_RESULTS_NAVIGATION = 'REQUEST_RESULTS_NAVIGATION';
export const RECEIVE_RESULTS_NAVIGATION = 'RECEIVE_RESULTS_NAVIGATION';

export const SET_RESULT_ERROR = 'SET_RESULT_ERROR';
export const SET_ADVANCED_SEARCH_TAB = 'SET_ADVANCED_SEARCH_TAB';

export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE';
export const RECEIVE_DICTIONARY = 'RECEIVE_DICTIONARY';

export const SET_API_ADDRESS = 'SET_API_ADDRESS';
export const RESET_API_ADDRESS = 'RESET_API_ADDRESS';

export const SET_CSV_ADDRESS = 'SET_CSV_ADDRESS';
export const RESET_CSV_ADDRESS = 'RESET_CSV_ADDRESS';

export const SET_FONT_SIZE = 'SET_FONT_SIZE';
export const SET_CONTRAST = 'SET_CONTRAST';

export const RECEIVE_TAB_DATA = 'RECEIVE_TAB_DATA';
export const REQUEST_TAB_DATA = 'REQUEST_TAB_DATA';
export const REQUEST_SIMPLE_SEARCH_RESULTS = 'REQUEST_SIMPLE_SEARCH_RESULTS';
export const RECEIVE_SIMPLE_SEARCH_RESULTS = 'RECEIVE_SIMPLE_SEARCH_RESULTS';
export const IS_FIELDS_OPEN = 'IS_FIELDS_OPEN';

export const SET_TAB_ERROR = 'SET_TAB_ERROR';
export const WRONG_QUERY_ERROR = 'WRONG_QUERY_ERROR';
export const SET_SIMPLE_SEARCH_RESULTS_ERROR = 'SET_SIMPLE_SEARCH_RESULTS_ERROR';
export const SIMPLE_SEARCH_WRONG_QUERY_ERROR = 'SIMPLE_SEARCH_WRONG_QUERY_ERROR';

export const SET_SIMPLE_SEARCH_RESULTS_TAB = 'SET_SIMPLE_SEARCH_RESULTS_TAB';

export const SET_FILTER = 'SET_FILTER';
export const SET_TAB_NAV = 'SET_TAB_NAV';
export const RESET_TAB_NAV = 'RESET_TAB_NAV';

export const APPLY_FILTER = 'APPLY_FILTER';
export const EXPAND_TREE = 'EXPAND_TREE';

export const REQUEST_LOAD_FILTER_BY_NAME = 'REQUEST_LOAD_FILTER_BY_NAME';
export const RECEIVE_LOAD_FILTER_BY_NAME = 'RECEIVE_LOAD_FILTER_BY_NAME';
export const LOAD_FILTER_BY_NAME_ERROR = 'LOAD_FILTER_BY_NAME_ERROR';

export const SET_IS_BLOCKED = 'SET_IS_BLOCKED';
export const RESET_IS_BLOCKED = 'RESET_IS_BLOCKED';

export const REMOVE_FROM_APPLIED = 'REMOVE_FROM_APPLIED';
export const CLEAN_ALL_FILTERS = 'CLEAN_ALL_FILTERS';
export const CLEAN_ALL_FILTERS_HEADINGS = 'CLEAN_ALL_FILTERS_HEADINGS';
export const RESET_FILTERS = 'RESET_FILTERS';

export const RESET_HEADINGS_FILTERS = 'RESET_HEADINGS_FILTERS';
export const UPDATE_HEADING_FILTERS = 'UPDATE_HEADING_FILTERS';
export const UPDATE_HEADING_FILTERS_SELECT = 'UPDATE_HEADING_FILTERS_SELECT';
export const UPDATE_HEADING_FILTERS_SELECT_RELATED = 'UPDATE_HEADING_FILTERS_SELECT_RELATED';

export const RECEIVE_CHARACTER_DATA = 'RECEIVE_CHARACTER_DATA';
export const SET_CHARACTER_ERROR = 'SET_CHARACTER_ERROR';
export const REQUEST_CHARACTER_DATA = 'REQUEST_CHARACTER_DATA';

export const REQUEST_HEADINGS_ABOUT = 'REQUEST_HEADINGS_ABOUT';
export const RECEIVE_HEADINGS_ABOUT = 'RECEIVE_HEADINGS_ABOUT';
export const SET_CHARACTER_HEADINGS_ABOUT_ERROR = 'SET_CHARACTER_HEADINGS_ABOUT_ERROR';

export const REQUEST_HEADINGS_ROOTS = 'REQUEST_HEADINGS_ROOTS';
export const RECEIVE_HEADINGS_ROOTS = 'RECEIVE_HEADINGS_ROOTS';
export const SET_CHARACTER_HEADINGS_ROOTS_ERROR = 'SET_CHARACTER_HEADINGS_ROOTS_ERROR';

export const RECEIVE_HEADINGS_CHILDREN = 'RECEIVE_HEADINGS_CHILDREN';
export const REQUEST_HEADINGS_CHILDREN = 'REQUEST_HEADINGS_CHILDREN';
export const SET_CHARACTER_HEADING_CHILDREN_ERROR = 'SET_CHARACTER_HEADING_CHILDREN_ERROR';

export const RECEIVE_HEADINGS_TITLE_RESULTS = 'RECEIVE_HEADINGS_TITLE_RESULTS';
export const REQUEST_HEADINGS_TITLE_RESULTS = 'REQUEST_HEADINGS_TITLE_RESULTS';
export const SET_CHARACTER_HEADING_TITLE_RESULTS_ERROR = 'SET_CHARACTER_HEADING_TITLE_RESULTS_ERROR';

export const SET_HEADINGS_SEARCH_KEY = 'SET_HEADINGS_SEARCH_KEY';
export const RESET_HEADINGS_SEARCH_KEY = 'RESET_HEADINGS_SEARCH_KEY';

export const RECEIVE_FIELD_CHILDREN = 'RECEIVE_FIELD_CHILDREN';

export const RECEIVE_HEADER_MENU = 'RECEIVE_HEADER_MENU';
export const RECEIVE_FOOTER_MENU = 'RECEIVE_FOOTER_MENU';
export const RECEIVE_FOOTER_SITEMAP = 'RECEIVE_FOOTER_SITEMAP';

export const RECEIVE_HEADINGS_INFO = 'RECEIVE_HEADINGS_INFO';

export const RECEIVE_NEWS_MAIN_PAGE = 'RECEIVE_NEWS_MAIN_PAGE';
export const REQUEST_NEWS_MAIN_PAGE = 'REQUEST_NEWS_MAIN_PAGE';
export const SET_NEWS_MAIN_PAGE_ERROR = 'SET_NEWS_MAIN_PAGE_ERROR';

export const RECEIVE_POS_MAIN_PAGE = 'RECEIVE_POS_MAIN_PAGE';
export const REQUEST_POS_MAIN_PAGE = 'REQUEST_POS_MAIN_PAGE';
export const SET_POS_MAIN_PAGE_ERROR = 'SET_POS_MAIN_PAGE_ERROR';

export const RECEIVE_PBL_NUMBER = 'RECEIVE_PBL_NUMBER';
export const REQUEST_PBL_NUMBER = 'REQUEST_PBL_NUMBER';
export const SET_PBL_NUMBER_ERROR = 'SET_PBL_NUMBER_ERROR';

export const RECEIVE_WHAT_IN_PBL = 'RECEIVE_WHAT_IN_PBL';
export const REQUEST_WHAT_IN_PBL = 'REQUEST_WHAT_IN_PBL';
export const SET_WHAT_IN_PBL_ERROR = 'SET_WHAT_IN_PBL_ERROR';

export const RECEIVE_ABOUT_PBL_SUBPAGE = 'RECEIVE_ABOUT_PBL_SUBPAGE';
export const REQUEST_ABOUT_PBL_SUBPAGE = 'REQUEST_ABOUT_PBL_SUBPAGE';
export const SET_ABOUT_PBL_SUBPAGE_ERROR = 'SET_ABOUT_PBL_SUBPAGE_ERROR';

export const RECEIVE_ABOUT_PBL_EXAMPLES = 'RECEIVE_ABOUT_PBL_EXAMPLES';
export const REQUEST_ABOUT_PBL_EXAMPLES = 'REQUEST_ABOUT_PBL_EXAMPLES';
export const SET_ABOUT_PBL_EXAMPLES_ERROR = 'SET_ABOUT_PBL_EXAMPLES_ERROR';

export const RECEIVE_NEWS_SUBPAGE = 'RECEIVE_NEWS_SUBPAGE';
export const REQUEST_NEWS_SUBPAGE = 'REQUEST_NEWS_SUBPAGE';
export const SET_NEWS_SUBPAGE_ERROR = 'SET_NEWS_SUBPAGE_ERROR';

export const RECEIVE_NEWS_CATEGORY = 'RECEIVE_NEWS_CATEGORY';
export const REQUEST_NEWS_CATEGORY = 'REQUEST_NEWS_CATEGORY';
export const SET_NEWS_CATEGORY_ERROR = 'SET_NEWS_CATEGORY_ERROR';

export const RECEIVE_NEWS_ITEM = 'RECEIVE_NEWS_ITEM';
export const REQUEST_NEWS_ITEM = 'REQUEST_NEWS_ITEM';
export const SET_NEWS_ITEM_ERROR = 'SET_NEWS_ITEM_ERROR';

export const RECEIVE_COLLECTIONS = 'RECEIVE_COLLECTIONS';
export const REQUEST_COLLECTIONS = 'REQUEST_COLLECTIONS';
export const SET_COLLECTIONS_ERROR = 'SET_COLLECTIONS_ERROR';

export const RECEIVE_COLLECTIONS_ABOUT = 'RECEIVE_COLLECTIONS_ABOUT';
export const REQUEST_COLLECTIONS_ABOUT = 'REQUEST_COLLECTIONS_ABOUT';
export const SET_COLLECTIONS_ABOUT_ERROR = 'SET_COLLECTIONS_ABOUT_ERROR';

export const RECEIVE_HEADING_DETAILS = 'RECEIVE_HEADING_DETAILS';
export const REQUEST_HEADING_DETAILS = 'REQUEST_HEADING_DETAILS';
export const SET_HEADING_DETAILS_ERROR = 'SET_HEADING_DETAILS_ERROR';

export const RESET_APPLY_FILTER = 'RESET_APPLY_FILTER';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';

export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const CLEAR = 'CLEAR';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js